import schemas from "@/db/schemas";

// µServices clients
import { materialRestClient } from "./clients/materialClient";
import { UserManagementClient } from "./clients/userManagementClient";
import { AgencyClient } from "./clients/agencyClient";
import { sampleRestClient } from "./clients/sampleClient";
import { ReportTemplateClient } from "./clients/reportTemplateClient";
import { installationTemplateRestClient } from "./clients/templateClient";

// Atmo clientsRest
// GRPC to migrate
import { orderFormRestClient } from "./clients/orderFormClient";
import { analysisRestClient } from "./clients/analysisClient";
import { SumClient } from "./clients/sumClient";
import { ReportClient } from "./clients/reportClient";
import { ClientClient } from "./clients/clientClient";

// MIX
import { installationRestClient } from "./clients/installationClient";
import { projectClientRest } from "./clients/projectClient";

// Full REST
import { analysisResultRestClient } from "./clients/analysisResultClient";
import { caseRestClient } from "./clients/caseClient";
import { configurationLineRestClient } from "./clients/configurationLineClient";
import { phaseRestClient } from "./clients/phaseClient";
import { parameterRestClient } from "./clients/parameterClient";
import { sampleFlaskRestClient } from "./clients/sampleFlaskClient";
import { acquisitionBookRestClient } from "./clients/acquisitionRecordBooksClient";
import RecordBookClient from "./clients/recordBookClient";
import { constatRestClient } from "./clients/constatClient";
import { reportExportRestClient } from "./clients/reportExportClient";
import { vleRestClient } from "./clients/vleClient";
import { flowRestClient } from "./clients/flowClient";
import { userRestClient } from "./clients/userClient";
import { adminInformationRestClient } from "./clients/adminInformationClient";
import { sampleFlaskPropRestClient } from "./clients/sampleFlaskPrepClient";
import { generationformclient } from "./clients/generationForm";

const models = schemas.models;
const modelToApiMapping = {
  [models.Project.tableName]: projectClientRest,
  [models.Client.tableName]: ClientClient,
  [models.Material.tableName]: materialRestClient,
  [models.User.tableName]: userRestClient,
  [models.Agency.tableName]: AgencyClient,
  [models.Phase.tableName]: phaseRestClient,
  [models.Parameter.tableName]: parameterRestClient,
  [models.Installation.tableName]: installationRestClient,
  [models.ConfigurationLine.tableName]: configurationLineRestClient,
  [models.Sample.tableName]: sampleRestClient,
  [models.Sum.tableName]: SumClient,
  [models.Report.tableName]: ReportClient,
  [models.Vle.tableName]: vleRestClient,
  [models.Flow.tableName]: flowRestClient,
  [models.SampleFlask.tableName]: sampleFlaskRestClient,
  [models.RecordBook.tableName]: RecordBookClient,
  [models.OrderForm.tableName]: orderFormRestClient,
  [models.AnalysisResult.tableName]: analysisResultRestClient,
  [models.Constat.tableName]: constatRestClient,
  [models.AdminInformation.tableName]: adminInformationRestClient,
  [models.AcquisitionRecordBook.tableName]: acquisitionBookRestClient,
  [models.SampleFlaskPrep.tableName]: sampleFlaskPropRestClient,
};

export {
  ClientClient,
  caseRestClient,
  materialRestClient,
  constatRestClient,
  reportExportRestClient,
  userRestClient,
  UserManagementClient,
  AgencyClient,
  installationRestClient,
  configurationLineRestClient,
  sampleRestClient,
  sampleFlaskRestClient,
  SumClient,
  phaseRestClient,
  parameterRestClient,
  ReportClient,
  ReportTemplateClient,
  vleRestClient,
  flowRestClient,
  analysisRestClient,
  modelToApiMapping,
  RecordBookClient,
  orderFormRestClient,
  analysisResultRestClient,
  adminInformationRestClient,
  acquisitionBookRestClient,
  installationTemplateRestClient,
  sampleFlaskPropRestClient,
  projectClientRest,
  generationformclient,
};
